import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const OperationsFuelQualityRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--operations--fuel-quality']}>
    <Route index element={<Index />} />
  </SubRouter>
))
